import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

function Success() {
  return (
    <Box sx={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#3F47F5',
      gap: 3
    }}>
      <CircularProgress sx={{ color: '#FFFFFF' }} size={60} />
      <Typography variant="h6" sx={{ color: '#FFFFFF', fontWeight: 500 }}>
        Accesso completato...
      </Typography>
    </Box>
  );
}

export default Success;
